import { SectorSelectDialogProps } from '../../types/inventory'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React, { useState } from 'react'
import { useMountEffect } from 'primereact/hooks'
import { Ripple } from 'primereact/ripple'
import PrimeReact from 'primereact/api'
import AreaOrSectorSaveDialog from './AreaOrSectorSaveDialog'
import { isEmpty } from 'lodash'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const AreaSelectDialog = (props: SectorSelectDialogProps) => {
    const { t } = useTranslation()
    PrimeReact.ripple = true

    useMountEffect(() => {
        // findArea()
    })

    const [addItemVisible, setAddItemVisible] = useState<boolean>(false)

    const onClickSector = (sectorId: string) => {
        console.log('onClickSector(' + sectorId)
        if (isEmpty(sectorId)) {
            props.onHide('')
        } else {
            props.onHide(sectorId)
        }
    }

    const onClickAddArea = () => {
        setAddItemVisible(true)
    }

    const footer = () => {
        return (
            <div className="grid">
                <div className="col-6">
                    <Button className="w-full p-button-secondary mt-4" label={t(tokens.common.close)} size="large" onClick={() => props.onHide('')} />
                </div>
                <div className="col-6">
                    <Button
                        className="w-full p-button-info mt-4 col-6"
                        icon="pi pi-plus"
                        iconPos="left"
                        label={t(tokens.common.add)}
                        size="large"
                        onClick={onClickAddArea}
                    />
                </div>
            </div>
        )
    }

    const onHideAddDialog = (isChange: boolean) => {
        if (isChange) {
            props.onAddLocation('SECTOR')
        }
        setAddItemVisible(false)
    }

    return (
        <>
            <Dialog
                header="섹터(Sector) 선택"
                visible={props.visible}
                onHide={() => props.onHide('')}
                closable={false}
                contentClassName="pb-0"
                footer={footer}
                style={{ width: '60vh' }}
            >
                <div style={{ minHeight: '300px', maxHeight: '350px' }}>
                    {props.sectors &&
                        props.sectors.map((area) => (
                            <div key={`${area.areaId}${area.sectorId}`}>
                                <div className="font-bold text-2xl border-bottom-1 py-4 p-ripple" onClick={() => onClickSector(area.sectorId)}>
                                    {area.sectorNm}
                                    <Ripple />
                                </div>
                            </div>
                        ))}
                </div>
                {addItemVisible && <AreaOrSectorSaveDialog visible={addItemVisible} onHide={onHideAddDialog} />}
            </Dialog>
        </>
    )
}

export default AreaSelectDialog
